import '@mathflat/design-system-2024/styles'

import type { DesignSystemTypes } from '@mathflat/design-system-2024'
import { createSwitch } from '@mathflat/design-system-2024'

const { Switch: DesignSystemSwitch } = createSwitch({
  checked: 'var(--Colors-Sky-400)',
  checkedHover: 'var(--Colors-Sky-500)',
  unchecked: 'var(--Colors-Gray-500)',
  uncheckedHover: 'var(--Colors-Gray-600)',
  focusRingColor: 'var(--Colors-Sky-600)',
})

/**
 * @description on/off 상황에서 사용하는 스위치(토글) 컴포넌트입니다.
 * @checked 체크 상태 boolean
 * @onCheckedChange 체크 상태 변경 시 실행되는 함수 (checked) => void
 * SwitchWithLabel은 추후 구현 예정입니다.
 */
export const Switch = ({
  id,
  size,
  checked,
  onCheckedChange,
  disabled,
}: {
  id?: string
  size: DesignSystemTypes.CommonSize
  checked: boolean
  onCheckedChange: (checked: boolean) => void
  disabled?: boolean
}) => {
  return (
    <DesignSystemSwitch
      id={id}
      size={size}
      checked={checked}
      onCheckedChange={onCheckedChange}
      disabled={disabled}
    />
  )
}
